import React from 'react';
import { Button } from './Button';

// LoadErrorState - the one way a failed load is shown (V2-020; DESIGN.md STATE-02).
//
// A plain sentence – "Couldn't load purchase orders. Try again." – with a Retry button. Never the
// raw error, never "No [records] found", never a count of 0: a failed request is not an empty
// result. The detail is already logged (Bugsnag); nothing from the error body is shown.

export interface LoadErrorStateProps {
  /** What failed to load, lower case: "purchase orders", "activities", "this tile". */
  what: string;
  /** Runs the load again. Without it the message is shown alone. */
  onRetry?: () => void;
  /** Smaller text and button, for Home tiles. */
  compact?: boolean;
  className?: string;
}

export function loadErrorMessage(what: string): string {
  return `Couldn't load ${what}. Try again.`;
}

export const LoadErrorState: React.FC<LoadErrorStateProps> = ({ what, onRetry, compact = false, className = '' }) => (
  <div
    role="alert"
    data-testid="load-error"
    className={`tw-flex tw-flex-wrap tw-items-center tw-gap-2 ${compact ? 'tw-text-sm tw-pt-2' : 'tw-rounded tw-border tw-border-danger/40 tw-bg-danger/5 tw-p-3'} tw-text-danger ${className}`}
  >
    <span>{loadErrorMessage(what)}</span>
    {onRetry && (
      <Button type="button" size="sm" variant="outline-secondary" onClick={onRetry}>
        Retry
      </Button>
    )}
  </div>
);

export default LoadErrorState;
